import axios from "axios";

const api_root = process.env["VUE_APP_ROOT_API"];

export default axios.create({
  baseURL: api_root,
  headers: {
    // Accept: "application/json",
    // "Content-Type": "application/json"
    // "Content-Type": "text/html; charset=UTF-8",
    // "Content-Encoding": "gzip",
    // "Accept-Encoding": "gzip"
    // Accept: "text/html"
  },
});
